var map = {
	"./de.json": 894,
	"./en.json": 174,
	"./es.json": 725,
	"./fr.json": 605,
	"./it.json": 672,
	"./ko.json": 423,
	"./pl.json": 29,
	"./pt.json": 741,
	"./tr.json": 755,
	"./zh.json": 527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 432;